<template>
    <div class="live">
        <template v-if="liveList && liveList.event && liveList.event.length > 0">
            <div class="header">
                <p></p>
                <p class="zhong">
                    <span>{{liveList.base_info.home_team_name}}</span><em>主/客 </em><span>{{liveList.base_info.away_team_name}}</span>
                </p>
                <p>
                    <i @click="changeGolob = 9" v-show="changeGolob == 0"></i>
                    <i  @click="changeGolob = 0" v-show="changeGolob == 9"></i>
                    只看进球
                </p>
            </div>
            <div class="content">
                <div class="item">
                    <div class="event home none"></div>
                     <div class="time">
                        <span>
                            <img src="../../assets/img/matchDetails/shijian.png" alt="">
                        </span>
                    </div>
                     <div class="event away none"></div>
                </div>
                <template  v-for="item,index in liveList.event">
                    <div class="item" :key="index" v-if="changeGolob == 0 ? true : item.type_id == changeGolob">
                        <div class="event home" :class="{none:item.team != 1}">
                            <div v-if="item.team == 1">
                                <p>
                                    <span>{{item.player_name || liveList.base_info.home_team_name + '球员'}}</span>
                                    <span v-if="item.player_name2 && item.type_id != 9">{{item.player_name2 || liveList.base_info.home_team_name + '球员'}}</span>
                                </p>
                                <p>
                                    <img v-if="item.type_id == 23" src="../../assets/img/matchDetails/huanren.png" alt="">
                                    <img v-else-if="item.type_id == 18" src="../../assets/img/matchDetails/linBox_yellow.png" alt="">
                                    <img v-else-if="item.type_id == 22" src="../../assets/img/matchList/paper_red.png" alt=""/>
                                    <img v-else-if="item.type_id == 21" src="../../assets/img/matchList/paper_two.png" alt=""/>
                                    <!-- 点球 -->
                                    <template v-if="item.type_id == 9">
                                        <img v-if="item.goal_type == 4"  src="../../assets/img/matchList/goal_dq.png" alt="">
                                        <!-- 乌龙球 -->
                                        <img v-else-if="item.goal_type == 2" src="../../assets/img/matchList/goal_wl.png" alt="">
                                        <img v-else src="../../assets/img/matchDetails/linBox_go.png" alt="">
                                        <!-- <template v-if="item.player_name2">
                                            <img src="../../assets/img/matchDetails/zhugong.png" alt="">
                                        </template> -->
                                    </template>
                                </p>
                            </div>
                        </div>
                        <div class="time">
                            <span>
                                {{parseInt(item.time / 60)}}′
                            </span>
                        </div>
                        <div class="event away" :class="{none:item.team != 2}">
                            <div  v-if="item.team == 2">
                                <p>
                                    <img v-if="item.type_id == 23" src="../../assets/img/matchDetails/huanren.png" alt="">
                                    <img v-else-if="item.type_id == 18" src="../../assets/img/matchDetails/linBox_yellow.png" alt="">
                                    <img v-else-if="item.type_id == 22" src="../../assets/img/matchList/paper_red.png" alt=""/>
                                    <img v-else-if="item.type_id == 21" src="../../assets/img/matchList/paper_two.png" alt=""/>
                                    <!-- 点球 -->
                                    <template v-if="item.type_id == 9">
                                        <img v-if="item.goal_type == 4"  src="../../assets/img/matchList/goal_dq.png" alt="">
                                        <!-- 乌龙球 -->
                                        <img v-else-if="item.goal_type == 2" src="../../assets/img/matchList/goal_wl.png" alt="">
                                        <img v-else src="../../assets/img/matchDetails/linBox_go.png" alt="">
                                        <!-- <template v-if="item.player_name2">
                                            <img src="../../assets/img/matchDetails/zhugong.png" alt="">
                                        </template> -->
                                    </template>
                                </p>
                                <p>
                                    <span>{{item.player_name || liveList.base_info.away_team_name + '球员'}}</span>
                                    <span v-if="item.player_name2 && item.type_id != 9">{{item.player_name2 || liveList.base_info.away_team_name + '球员'}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="item">
                    <div class="event home none"></div>
                     <div class="time">
                        <span>
                            <img src="../../assets/img/matchDetails/kaishi.png" alt="">
                        </span>
                    </div>
                     <div class="event away none"></div>
                </div>
            </div>
        </template>
        <template v-else>
             <div class="empty">
                <span><img src="../../assets/img/matchDetails/empty.png" alt=""></span>
                <span>暂无数据！</span> 
            </div>
        </template>
        <div class="foter">
            <div class="left">图例说明</div>
            <div class="right">
                <p>
                    <span><img src="../../assets/img/matchDetails/jingqiu.png" alt=""></span>
                    <span>进球</span>
                </p>
                <p>
                    <span><img src="../../assets/img/matchDetails/dianqiu.png" alt=""></span>
                    <span>点球</span>
                </p>
                <p>
                    <span><img src="../../assets/img/matchDetails/wulong.png" alt=""></span>
                    <span>乌龙球</span>
                </p>
                <p>
                    <span><img src="../../assets/img/matchDetails/linBox_yellow.png" alt=""></span>
                    <span>黄牌</span>
                </p>
                <p>
                    <span><img src="../../assets/img/matchDetails/hong.png" alt=""></span>
                    <span>红牌</span>
                </p>
                <p>
                    <span><img src="../../assets/img/matchDetails/lainghuang.png" alt=""></span>
                    <span>两黄变红</span>
                </p>
                <p>
                    <span><img src="../../assets/img/matchDetails/huanren.png" alt=""></span>
                    <span>换人</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { matchEvent } from "../../api/api"
export default {
    name: "live",
    props: ['match_id', 'status', 'tabs'],
    data () {
        return {
            liveList: [],
            changeGolob: 0,
            time: null
        }
    },
    watch: {
        tabs: {
            handler (news) {
                if (news == 1) {
                    this.forFun()
                } else {
                    clearInterval(this.time)
                }
            },
            immediate: true
        },
        match_id () {
            this.forFun()
        }
    },
    methods: {
        forFun () {
            clearInterval(this.time)
            if (this.tabs != 1) return
            if (this.status == 2) {
                this.getLiveList()
                this.time = setInterval (() => {
                    this.getLiveList()
                },30000)
            } else {
                clearInterval(this.time)
                this.getLiveList()
            }
        },
        async getLiveList () {
            let params = {
                match_id: this.match_id
            }
            let params2 = {}
            if (this.status == 2) {
                params2.r = parseInt(new Date().getTime() / 1000) 
            }
            const res = await matchEvent(params,params2)
            if (res.code == 0) {
                this.liveList = res.data
            }
        }
    }
}
</script>

<style lang="less">
.live{
    .empty{
        height: 600px;
        // box-shadow: 0px 0px 20px 0px rgba(21, 21, 21, 0.06);
        display: flex;
        flex-direction: column;
        justify-content: center;
        span{
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            &:first-child{
                padding-top:32px ;
                margin-bottom:10px ;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: 180px;
                 height: 140px;  
                }
                
            }
        }
    }
    position: relative;
    height: 100%;
    .header{
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        height: 50px;
        align-items: center;
        p{
            flex: 1;
            text-align: center;
            &:first-child{
                // flex: none;
                // width: 340px;
            }
            &:last-child{
                // flex: none;
                // width: 350px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding-right: 44px;
                i{
                    cursor: pointer;
                    &:first-child{
                        background: url("../../assets/img/matchList/icon_checkbox_table_normal.png");
                        &:hover{
                            background: url("../../assets/img/matchList/icon_checkbox_true.png");
                        }
                    }
                     &:last-child{
                        background: url("../../assets/img/matchList/icon_checkbox_table_selected.png");
                    }
                    height: 16px;
                    width: 16px;
                    background-size: 100%;
                    margin-right: 5px;
                }
            }
        }
        .zhong{
            flex: none;
            display: flex;
            width: 400px;
            justify-content: center;
            align-items: center;
            padding-left: 30px;
            span{
                width: 150px;
            }
            em{
                font-style: normal;
                width: 50px;
            }
        }
    }
    .content{
        height: 1005px;
        overflow: auto;
        .item{
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
            .event{
                // flex: 1;
                width: 286px;
                background: #F7F7FA;
                border-radius: 6px;
                display: flex;
                align-items: center;
                div{
                    display: flex;
                    align-items: center;
                }
                img{
                    width: 20px;
                    margin-bottom: 5px;
                    &:nth-child(2) {
                        margin:0;
                        margin-top: 5px;
                    }
                }
            }
            .none{
                background: #fff;
                &::after{
                    border: none !important;
                }
                &::before{
                    border: none !important;
                }
            }
            .home{
                min-height: 40px;
                justify-content: flex-end;
                position: relative;
                div{
                        justify-content: flex-end;
                    p{
                        &:first-child{
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                            display: flex;
                            flex-direction: column;
                            align-items: flex-end;
                            margin-right: 17px;
                            span{
                                line-height: 30px;
                                // text-align: right;
                                // padding: 12px 0px;
                                // &:first-child{
                                //     padding-bottom: 0px;
                                // }
                            }
                        }
                        &:last-child{
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            margin-right: 5px;
                            span{
                                display: flex;
                                justify-content: center;
                                // align-items: center;
                                align-content: space-between;
                                // margin: 10px 0;
                                img{
                                    width: 21px;
                                    height: 21px;
                                }
                            }
                        }
                    }
                }
                &::after{
                    content: '';
                    position: absolute;
                    width: 0;
                    height: 0;
                    border-left: 15px solid #F7F7FA;
                    border-right: 10px solid transparent;;
                    border-bottom: 10px solid transparent;
                    border-top: 10px solid transparent;
                    right: -24px;
                }
            }
            .away{
                justify-content: flex-start;
                position: relative;
                min-height: 40px;
                div{
                        justify-content: flex-start;
                    p{
                        &:first-child{
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            margin-left: 5px;
                            span{
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                img{
                                    width: 21px;
                                    height: 21px;
                                }
                            }
                        }
                        &:last-child{
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            margin-left: 17px;
                            span{
                                line-height: 30px;
                                // padding: 12px 0px;
                                //  &:first-child{
                                //     padding-bottom: 0px;
                                // }
                            }
                        }
                    }
                }
                &::before{
                    content: '';
                    position: absolute;
                    width: 0;
                    height: 0;
                    border-right: 15px solid #F7F7FA;
                    border-left: 10px solid transparent;;
                    border-bottom: 10px solid transparent;
                    border-top: 10px solid transparent;
                    left: -24px;
                }
            }
            .time{
                padding: 0 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                span{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 30px;
                    height: 30px;
                    background: #F6F6F8;
                    border-radius: 15px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #83879D;
                    z-index: 100;
                    img{
                        width: 20px;
                    }
                }
                &::after{
                    content: '';
                    height: 100%;
                    border-right:1px dashed  #E1E0EB;
                    position: absolute;
                    margin: auto;
                    bottom: -36px;
                }
            }
            &:last-child{
                .time{
                    &::after{
                        border: none;
                    }
                }
            }
        }
    }
    .foter{
        // width: 870px;
        height: 50px;
        background:  #fff;
        position: absolute;
        z-index: 100;
        border-top:1px solid #EAE9F2 ;
        bottom: 0;
        display: flex;
        width: 100%;
        .left{
            width: 100px;
            line-height: 50px;
            font-size: 12px;
            font-weight: 500;
            color: #333333;
        }
        .right{
            display: flex;
            p{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 50px;
                margin-right:23px ;
                span{
                    &:first-child{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            width: 19px;
                            height: 19px;
                        }
                    }
                    &:last-child{
                        font-size: 12px;
                        font-weight: 500;
                        color: #7A809A;
                        margin-left: 9px;
                    }
                }
            }
        }
    }
}
</style>